import queries from '@apis/queries';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface Props {
    prepaidCardImageId: string;
}

function Summary({ prepaidCardImageId }:Props) {
    const { t } = useTranslation('prepaidCard');
    const { data } = useQuery(queries.prepaidCardImages.detail(prepaidCardImageId));
    return (
        <Wrapper>
            <Container spacing={16} >
                <CardImage src={data?.imageUrl}
                    width={90}
                    height={60}
                    alt={t('image.cardImageAlt')} />
                <Text size='xl'>{data?.title}</Text>
            </Container>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    background-color: var(--color-gray2);
    padding: 30px 20px;
    width: 100%;
`;

const Container = styled(Row)`
    background-color: var(--color-white);
    border: 1px solid var(--color-gray3);
    border-radius: 6px;
    padding: 16px;
    img {
        border-radius: 4px;
    }`;

const CardImage = styled(Image)`
    object-fit: cover;
`;

export default Summary;
